<template>
  <div>
    <detail v-if="haveCert==1"></detail>
    <div v-else>
      <p class="titH1">夏令营活动证书</p>
      <div v-for="(item, index) in certList" :key="index" class="certs">
        <iframe width="100%" height="100%" :src="item.url" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import detail from './components/detail.vue'
// import Certificate from './components/Certificate.vue'
export default {
  components: {
    detail,
    //  Certificate
  },
  data() {
    return {
      haveCert: null,
      certList: []
    }
  },
  methods: {
    sureCert() {
      this.$http.get(`/camp/queryFj`)
        .then(res => {
          let data = res.data.data
          if (data.length == 0) {
            // 没有证书
            this.haveCert = 1
          } else {
            this.haveCert = 2
            this.certList = data
          }
          
          console.log('this.haveCert', this.haveCert);
        })
        .catch(err => {
          console.log(err);
        })
    }
  },
  created() {
    this.sureCert()
    // this.loadOption()
  }
}
</script>

<style scoped lang="scss">
.titH1{
    font-size: 30px;
    text-align: center;
    padding: 20px;
    color: #68b7ff;
    font-weight: 600;
}
.certs {
  width: 100%;
  height: 100vh;
  margin-bottom: 30px;
}
</style>